export var SCROLL_TIMEOUT = 500;
export var VISIBLE_PADDING = 300;
export var DEFAULT_CONTAINER_WIDTH = 1024;
export var DEFAULT_SPACING = 16;
// See https://zpl.io/VKPoDRR
export var DEFAULT_BREAKPOINTS = [
    {
        maxWidth: 480,
        elementWidth: 280,
        elementHeight: 280,
    },
    {
        maxWidth: 1024,
        elementWidth: 304,
        elementHeight: 261,
    },
    {
        maxWidth: 1280,
        elementWidth: 288,
        elementHeight: 247,
    },
    {
        maxWidth: 1366,
        elementWidth: 299.5,
        elementHeight: 257,
    },
    {
        maxWidth: 1920,
        elementWidth: 347.2,
        elementHeight: 300,
    },
];
export var pageMarginByScreenWidth = {
    480: 100,
    1024: 40,
    1280: 40,
    1366: 60,
    1920: 60,
};
//# sourceMappingURL=constants.js.map